import { PropsWithChildren } from "react"
import { useAppSelector } from "../store/storeHooks"
import { UserType } from "../login/loginTypes"
import { selectEffectiveUserType } from "../context/contextSelectors"

type HideForUserTypeProps = Readonly<
    PropsWithChildren<{
        userTypes: UserType[]
    }>
>

export function HideForCurrentUserType({ userTypes, children }: HideForUserTypeProps) {
    const actualUserType = useAppSelector(selectEffectiveUserType)

    if (actualUserType && userTypes.includes(actualUserType)) {
        return null
    }

    return <>{children}</>
}
